import {
  IEmailDistributionList,
  IEmailRecipientFilterGroup,
} from "../../interfaces/models/IEmailDistributionList";
import { RecipientListDropdownOption } from "./usePaginatedEmailDistributionLists";

export const ALL_ACTIVE_MEMBERS_RECIPIENT_LIST_ID =
  "__builtin:all-active-members__";

export const ALL_ACTIVE_MEMBERS_RECIPIENT_LIST_NAME = "All active members";

const ALL_ACTIVE_MEMBERS_FILTER: IEmailRecipientFilterGroup = {
  logic: "AND",
  conditions: [
    {
      field: "membershipStatus",
      comparison: "IN",
      value: ["Member"],
    },
  ],
};

const BUILTIN_RECIPIENT_LIST_DROPDOWN_OPTIONS: RecipientListDropdownOption[] = [
  {
    id: ALL_ACTIVE_MEMBERS_RECIPIENT_LIST_ID,
    name: ALL_ACTIVE_MEMBERS_RECIPIENT_LIST_NAME,
  },
];

export function isBuiltinRecipientListId(
  id: string | undefined | null,
): boolean {
  return id === ALL_ACTIVE_MEMBERS_RECIPIENT_LIST_ID;
}

/** Built-in lists that skip the Step 2 condition builder. */
export function isSkipStep2RecipientListId(
  id: string | undefined | null,
): boolean {
  return isBuiltinRecipientListId(id);
}

export function getBuiltinEmailDistributionList(
  id: string,
): IEmailDistributionList | null {
  if (id !== ALL_ACTIVE_MEMBERS_RECIPIENT_LIST_ID) {
    return null;
  }

  return {
    id: ALL_ACTIVE_MEMBERS_RECIPIENT_LIST_ID,
    name: ALL_ACTIVE_MEMBERS_RECIPIENT_LIST_NAME,
    filter: ALL_ACTIVE_MEMBERS_FILTER,
    isTestList: false,
  };
}

export function getMatchingBuiltinRecipientListOptions(
  searchQuery: string,
): RecipientListDropdownOption[] {
  const query = searchQuery.trim().toLowerCase();
  if (!query) {
    return BUILTIN_RECIPIENT_LIST_DROPDOWN_OPTIONS;
  }

  return BUILTIN_RECIPIENT_LIST_DROPDOWN_OPTIONS.filter((option) =>
    option.name.toLowerCase().includes(query),
  );
}
